<template>
  <!-- invoicing done successfully confirmation -->
  <div class="modal fade invoiced-record-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header d-none">
          <h4 class="modal-title text-uppercase" id="myLargeModalLabel">Acknowledgment confirmartion</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">

            <!-- Confirmation Icon and Message -->
            <!-- Confirmation Icon and Message -->
            <div class="col-12 d-flex align-items-center justify-content-center pt-3">
              <div class="p-4 px-5 d-flex align-items-center justify-content-center flex-column pt-5">
                <div class="flex-shrink-0 align-self-center mb-4">
                  <div class="avatar-md rounded-circle bg-primary mini-stat-icon" title="Action Successful">
                    <span class="avatar-title rounded-circle bg-success" aria-label="Action Confirmed">
                        <i class="bx bx-check-double fs-1" title="Acknowledgment Successful" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
                <h4 class="text-uppercase text-success text-black modal-title" title="Acknowledgment Confirmed">{{Number(entry.year)+1}} Invoice Generated</h4>
                <p class="text-center px-5" title="Client notified of the invoice and details">
                  The {{Number(entry.year)+1}} SBP invoice for {{businessDetails.businessName}} was successfully generated for KES {{numberFormat(billDetails.detailAmount)}}. Invoice details were sent to the client via both email and SMS.
                </p>
              </div>
            </div>


            <!-- Business and Client Details -->
            <div class="col-12">
              <div class="table-responsive">
                <table class="table border border-info table-sm table-striped-info table-striped text-black" title="Business and Client Details">
                  <tbody class="text-black text-uppercase">
                  <tr>
                    <td title="Business Name">Business Name</td>
                    <th title="Volvo Office">{{businessDetails.businessName}}</th>
                  </tr>
                  <tr>
                    <td title="Owner's Name">Owner's Name</td>
                    <th title="">{{businessDetails.fullNames}}</th>
                  </tr>
                  <tr>
                    <td title="Client Email">Email</td>
                    <th title="Client Email">{{businessDetails.ownerEmail}}</th>
                  </tr>
                  <tr>
                    <td title="Client Phone Number">Phone Number</td>
                    <th title="Client Phone Number">{{businessDetails.ownerPhone}}</th>
                  </tr>
                  <tr>
                    <td title="Invoice Number">Invoice Number</td>
                    <th title="BLL77575675">{{billDetails.billNo}}</th>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Invoice Item Details -->
            <div class="col-12">
              <div class="table-responsive mt-2">
                <table class="table table-nowrap border border-dark text-uppercase" title="Invoice Item Details">
                  <thead class="bg-light">
                  <tr>
                    <th style="width: 70px;" title="Item Number">#</th>
                    <th title="Description of Invoice Item">Invoice Item</th>
                    <th class="text-right" title="Amount Charged">Amount</th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr :key="index" :value="item" v-for="(item, index) in billInfo">
                    <td title="Item 1">{{index+1}}</td>
                    <td title="Renewal Fee">{{item.feeDescription}}</td>
                    <td class="text-right">KES {{numberFormat(item.billTotal)}}</td>
                  </tr>


                  </tbody>
                  <tfoot class="border border-dark table-light">
                  <tr class="text-black">
                    <th colspan="2" title="Total Items">{{billInfo.length}} Invoice Items</th>
                    <th class="text-right" title="Total Amount">KES {{billDetails.detailAmount}}</th>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <!-- Summary and Payment Details -->
            <div class="col-8">
              <div class="table-responsive mt-4">
                <table class="table border border-success text-uppercase table-sm table-striped table-striped-success">
                  <tbody>
                  <tr>
                    <th>Invoice Date</th>
                    <td class="text-black">{{formattedDate(billDetails.dateCreated)}}</td>
                  </tr>
                  <tr>
                    <th>Invoiced By</th>
                    <td class="text-black">{{billDetails.names}}</td>
                  </tr>
                  <tr>
                    <th>Invoice Amount</th>
                    <td class="text-black fs-2 fw-bold">KES {{billDetails.detailAmount}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="col-12 d-flex justify-content-end pt-4 text-uppercase">
              <a @click="onPrintBill(billDetails.billNo)" href="javascript: void(0);" target="_blank" type="button" class="btn btn-primary text-uppercase d-flex align-items-center revertAcknowledgment mx-2 w-100 text-center justify-content-center" id="revertButton" title="Print the generated permit">
                <div>Print Invoice</div>
                <div class="spinner-border text-white ms-2 d-none" style="height: 19px; width: 19px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </a>
            </div>

          </div>
        </div>



        <div class="modal-footer d-none">
          <button class="btn btn-sm btn-success text-uppercase d-flex align-items-center ms-2 Acknowledge-order" data-bs-toggle="modal" data-bs-target="#payment-modal" title="Initiate Payment for Lab Tests">
            <div>Acknowledge</div>
            <div class="spinner-border text-white ms-2 d-none" style="height: 19px; width: 19px;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </div>

      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.Approve application -->
  </div>
  <!-- end of confirmation -->
</template>

<script>
/* eslint-disable */
import moment from 'moment'

export default {
  name: "InvoicedRecordModal",
  props: {
    businessDetails: {
      type: Object,
      required: true
    },
    entry: {
      type: Object,
      required: true
    },
    billDetails: {
      type: Object,
      required: true
    },
    billInfo: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },
    formattedDate(date) {
      return moment(date).format('DD MMM YYYY hh:mm A') + ' (' + moment(date).fromNow() + ')';
    },
    onPrintBill(billNo) {
      this.$emit('printBill', billNo);
    }
  }
}
</script>

<style scoped>

</style>